'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getOwnPropertyDescriptor = require('babel-runtime/core-js/object/get-own-property-descriptor');

var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _get4 = require('babel-runtime/helpers/get');

var _get5 = _interopRequireDefault(_get4);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _get6 = require('lodash/get');

var _get7 = _interopRequireDefault(_get6);

var _clamp3 = require('lodash/clamp');

var _clamp4 = _interopRequireDefault(_clamp3);

var _desc, _value, _class, _class2, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _ClientSideComponent = require('core/ClientSideComponent');

var _ClientSideComponent2 = _interopRequireDefault(_ClientSideComponent);

var _reactDraggable = require('react-draggable');

var _reactDraggable2 = _interopRequireDefault(_reactDraggable);

var _bind = require('classnames/bind');

var _bind2 = _interopRequireDefault(_bind);

var _autobindDecorator = require('autobind-decorator');

var _autobindDecorator2 = _interopRequireDefault(_autobindDecorator);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

var styles = require('./DragBar.scss');

var cn = _bind2.default.bind(styles);

var DragBar = (_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(DragBar, _Component);

  function DragBar() {
    var _ref;

    (0, _classCallCheck3.default)(this, DragBar);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    var _this = (0, _possibleConstructorReturn3.default)(this, (_ref = DragBar.__proto__ || (0, _getPrototypeOf2.default)(DragBar)).call.apply(_ref, [this].concat(args)));

    _this.state = {
      dragPosition: { x: 0, y: 0 }
    };
    return _this;
  }

  (0, _createClass3.default)(DragBar, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      (0, _get5.default)(DragBar.prototype.__proto__ || (0, _getPrototypeOf2.default)(DragBar.prototype), 'componentDidMount', this).call(this, this.init);
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (typeof nextProps.value !== 'undefined' && nextProps.forceUpdate && nextProps.value !== this.props.value) {
        this.getProgress(null, null, nextProps.value);
      }
    }
  }, {
    key: 'onDrag',
    value: function onDrag(e, position) {
      var _getProgress = this.getProgress(e, position),
          progress = _getProgress.progress;

      if (this.props.onDrag) this.props.onDrag(e, position, progress);
    }
  }, {
    key: 'onDragStop',
    value: function onDragStop(e, position) {
      var _getProgress2 = this.getProgress(e, position),
          progress = _getProgress2.progress;

      if (this.props.onStop) this.props.onStop(e, position, progress);
    }
  }, {
    key: 'onDragStart',
    value: function onDragStart(e, position) {
      var _getProgress3 = this.getProgress(e, position),
          progress = _getProgress3.progress;

      if (this.props.onStart) this.props.onStart(e, position, progress);
    }
  }, {
    key: 'getProgress',
    value: function getProgress(e, position, value) {
      if (!this.progressBar) {
        return { x: 0, progress: 0 };
      }
      var barWidth = this.progressBar.clientWidth;
      var barRect = this.progressBar.getBoundingClientRect ? this.progressBar.getBoundingClientRect() : { left: 0 };

      var _ref2 = e || {},
          target = _ref2.target,
          nativeEvent = _ref2.nativeEvent;

      var newX = 0;

      if (target && nativeEvent) {
        var clientX = (0, _get7.default)(nativeEvent, 'clientX') || (0, _get7.default)(nativeEvent, 'touches[0].clientX', 0);
        newX = clientX - barRect.left;
      } else if (position) {
        newX = position.x;
      } else if (value) {
        newX = value * barWidth;
      }

      var x = (0, _clamp4.default)(newX, 0, barWidth);
      var progress = (0, _clamp4.default)(x / barWidth, 0, 1);

      this.updateState(x, 0, progress);

      return { x: x, progress: progress };
    }
  }, {
    key: 'init',
    value: function init() {
      var _getProgress4 = this.getProgress(null, null, this.props.value),
          x = _getProgress4.x,
          progress = _getProgress4.progress;

      if (this.props.onInit) this.props.onInit(x, progress);
    }
  }, {
    key: 'updateState',
    value: function updateState(x, y, progress) {
      this.setState({
        dragPosition: { x: x, y: y },
        progress: progress
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _state = this.state,
          dragPosition = _state.dragPosition,
          progress = _state.progress;
      var _props = this.props,
          subValue = _props.subValue,
          className = _props.className,
          progressBarClass = _props.progressBarClass,
          hideProgress = _props.hideProgress;

      var dragBarClass = cn('dragBar', className);

      return _react2.default.createElement(
        'div',
        { className: dragBarClass, ref: function ref(el) {
            return _this2.dragBar = el;
          } },
        _react2.default.createElement(
          'div',
          { className: cn('progressBar', progressBarClass), ref: function ref(el) {
              return _this2.progressBar = el;
            } },
          !!subValue && _react2.default.createElement('div', { className: styles.subProgress, style: { width: subValue * 100 + '%' } }),
          !hideProgress && _react2.default.createElement('div', { className: styles.progress, ref: function ref(el) {
              return _this2.progress = el;
            }, style: { width: progress * 100 + '%' } })
        ),
        _react2.default.createElement(
          'div',
          { className: styles.dragHolder, ref: function ref(el) {
              return _this2.dragHolder = el;
            } },
          _react2.default.createElement(
            _reactDraggable2.default,
            {
              axis: 'x',
              bounds: 'parent',
              position: dragPosition,
              onStart: this.onDragStart,
              onStop: this.onDragStop,
              onDrag: this.onDrag
            },
            _react2.default.createElement('span', { className: styles.dragPoint, ref: function ref(el) {
                return _this2.dragPoint = el;
              } })
          )
        )
      );
    }
  }]);
  return DragBar;
}(_ClientSideComponent2.default), _class2.propTypes = {
  className: _propTypes2.default.string,
  forceUpdate: _propTypes2.default.bool,
  hideProgress: _propTypes2.default.bool,
  onDrag: _propTypes2.default.func,
  onInit: _propTypes2.default.func,
  onStart: _propTypes2.default.func,
  onStop: _propTypes2.default.func,
  progressBarClass: _propTypes2.default.string,
  subValue: _propTypes2.default.number,
  value: _propTypes2.default.number
}, _temp), (_applyDecoratedDescriptor(_class.prototype, 'onDrag', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'onDrag'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'onDragStop', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'onDragStop'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'onDragStart', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'onDragStart'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'init', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'init'), _class.prototype)), _class);
exports.default = DragBar;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/DragBar/DragBar.js
// module id = 1987
// module chunks = 1